import { LockFilled } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import { Tooltip } from 'antd';
import React from 'react';
import { ISubmissionMenuItem } from './ISubmissionMenuItem';
import { SubmissionMenuLabel } from './SubmissionMenuLabel';

export interface ISubmissionMenuItemProps {
  item: ISubmissionMenuItem;
  badge?: React.ReactNode;
  disabled?: boolean;
}

export function SubmissionMenuItem(props: ISubmissionMenuItemProps) {
  const { item, badge, disabled } = props;
  const { t } = useTranslation();

  if (!item) return null;

  const disableText = t(
    'submission-menu-item.sezione-disabilitata',
    'Sezione disabilitata',
  );

  return (
    <FlexRow
      gutter={4}
      right={badge}
      left={
        disabled ? (
          <Tooltip title={disableText}>
            <span className="sr-only">{disableText}.</span>
            <LockFilled aria-hidden="true" />
          </Tooltip>
        ) : undefined
      }
    >
      <SubmissionMenuLabel item={item} />
    </FlexRow>
  );
}
